<template>
  <div>
    <div class="landing-cnt row">
      <!-- <div class="bg-heart"></div> -->
			<div class="bg-image">
				<div></div>
			</div>
      <!-- <div class="heart-image d-none d-lg-block"></div> -->
      <div class="col-12 d-landscape-none d-xl-none d-lg-flex main-block-xs my-auto">
				<!-- Título principal -->
				 <div class="d-block d-lg-none my-auto text-ctn-embedded pt-5 pt-lg-0">
					<h1 v-html="$t('patients-landing.mobile-title')"></h1>
					<h1 class="embedded-title">{{ $t('patients-landing.mobile-title-2') }}</h1>
				</div>
			</div>
      <!-- Main text block not logged -->
      <div class="text-block-ctn col-desktop-6 col-xl-6 col-landscape-6 col-12 d-flex my-auto pt-0 pt-lg-5">
        <div class="text-ctn m-auto mx-sm-0 w-100 mb-3 mb-lg-0">
					<div class="d-none d-lg-block my-auto">
						<h1 v-html="$t('patients-landing.mobile-title')"></h1>
						<h1 class="embedded-title">{{ $t('patients-landing.mobile-title-2') }}</h1>
						<!-- h1>{{ $t('patients-landing.mobile-title-lg') }}</h1> -->
					</div>
					<SimpleSearch/>
        </div>
      </div>
		</div>
		<!-- <svg viewBox="0 0 1440 150" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" >
			<path d="M0,64 C360,0 1080,128 1440,64 L1440,150 L0,150 Z" fill="#2F2FCF" />
		</svg> -->
		<BlueCenteredBlock class="blue-block" :title="$t('patients-landing.different-health')" :subtitle="$t('patients-landing-different-health-description')"/>

		<Blocks2x2Section class="my-5" />

		<div class="page">
			<div class="content-page d-none d-lg-block" id="profesional">
			</div>
			<div class="content-page" id="black">
				<div class="wrap-content">
					<h4 class="title white">{{ $t('patients-landing.independent-professionals') }}</h4>
					<h5 class="subtitle white">{{ $t('patients-landing.quality-medicine')  }}</h5>
					<p class="paragraph grey">{{ $t('patients-landing.sign-up-banner')  }}</p>
					<div class="wrap-buttons">
						<div class="first-button">
							<button class="item-button white-lineal" @click="() => { $router.push('/inicio-sesion') }" target="_blank">{{ $t('patients-landing.know-more') }}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<patients-landing-swiper :title="$t('patients-landing.swiper.title')"/>
		<div class="mb-5 pb-5 mx-auto text-center">
			<base-button variant="secondary" @click="$router.push('/inicio-sesion')" class="mt-4">{{ $t('patients-landing.sign-up-free') }}</base-button>
		</div>
		<div class="menttum-container">
			<div class="content">
				<h4 class="title">{{ $t('patients-landing.opensalud360-title') }}</h4>
					<h5 class="subtitle blue">{{  $t('patients-landing.opensalud360-subtitle') }}</h5>
					<p class="paragraph" v-html="$t('patients-landing.opensalud360-text')"></p>
					<div class="wrap-buttons">
						<div class="first-button">
							<button class="item-button white-solid" @click="() => { $router.push('/opensalud360/empresas') }" target="_blank">{{ $t('patients-landing.know-more') }}</button>
						</div>
					</div>
			</div>
			<div class="image-container">
				<div></div>
			</div>
		</div>
		<!-- <div class="menttum-container">
			<div class="content">
				<h4 class="title">{{ $t('patients-landing.access-psychologist') }}</h4>
					<h5 class="subtitle blue">{{ $t('patients-landing.online-inplace-attention') }}</h5>
					<p class="paragraph" v-html="$t('patients-landing.menttum-banner')"></p>
					<div class="wrap-buttons">
						<div class="first-button">
							<button class="item-button white-solid" @click="goToMenttum" target="_blank">{{ $t('patients-landing.go-menttum')}}</button>
						</div>
					</div>
			</div>
			<div class="image-container">
				<div></div>
			</div>
		</div> -->
		<!-- <div class="page black">
			<div class="content-page" id="lake"></div>
			<div class="content-page">
				<div class="wrap-content black">
					<h4 data-i18n="patients.business.title" class="title white">{{ $t('patients-landing.opensalud360-title') }}</h4>
					<h5 data-i18n="patients.business.subtitle" class="subtitle white">{{ $t('patients-landing.opensalud360-subtitle') }}</h5>
					<p data-i18n="patients.business.paragraph" class="paragraph grey">{{ $t('patients-landing.opensalud360-text') }}</p>
					<div class="wrap-buttons">
						<button class="item-button white-lineal" @click="() => { $router.push('/opensalud360/empresas') }" target="_blank">{{ $t('patients-landing.know-more') }}</button>
					</div>
				</div>
				
			</div>
		</div> -->
	</div>
</template>

<script>
import layoutMixin from '@/mixins/layout.mixin'
import PatientsLandingSwiper from '@/components/public/PatientsLandingSwiper.vue'
import SimpleSearch from '@/components/shared/SimpleSearch.vue'
import BlueCenteredBlock from '@/components/base/BlueCenteredBlock.vue'
import Blocks2x2Section from '@/components/public/landing/Blocks2x2Section.vue'

export default {
	name: 'Pacientes',
	mixins: [layoutMixin],
	components: {
		PatientsLandingSwiper,
		SimpleSearch,
		BlueCenteredBlock,
		Blocks2x2Section
	},
	methods: {
		goToMenttum () {
			window.location = 'https://menttum.com/'
		}
	}
}
</script>

<style lang="scss" scoped>
@import "static-appopensalud/css/public/views/opensalud_pacientes.scss";	


  /deep/ {
    .btn-min-height{
      @include desktop{
       min-height: 27rem !important;
      }
      @include desktop-sm{
       min-height: 27rem !important;
      }
    }
    .search-type{
        display: flex;
        gap: 1rem;
        // @include media(mobile) {
        //     flex-direction: column;
        // } 
    }
    .neu-card-general-ctn, .neu-card-professionals-ctn {
      @include mobile {

        padding-left: 2rem;
        padding-right: 2rem;
      }
    }
    .neu-card-general,
     .neu-card-professionals  {
      background-color: #eee;

    @include mobile {
        min-height: 300px;
        margin-right: 2%;
        -webkit-transition: all .5s ease;
        transition: all .5s ease;
        text-align: center;
        margin-top: auto;
        padding: 1rem;
        margin-bottom: 2rem;
    }
    @include tablets {
        min-height: 300px;
        margin-right: 2%;
        -webkit-transition: all .5s ease;
        transition: all .5s ease;
        text-align: center;
        margin-top: auto;
        padding: 1rem;
        margin-bottom: 2rem;
    }
    }
    .neu-card-general:hover {
    border: 2px solid #3238C4;
}
  }

.btn-text{
  cursor: pointer;
  color: $blue
}

.btn-text:hover{
  cursor: pointer;
  color: $blue;
  text-decoration: underline;
}

.seeker {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.5s, opacity 0.5s;
}
.btn-landing {
  font-weight: bold !important;

    }
.seeker.show {
  visibility: visible;
  opacity: 1;
}
.menu-cnt {
    font-weight: bold;

    p {
          color: $blue;
      
           @include desktop {
       &:is(:last-child) {
        margin-right: 1rem;
      }&:is(:first-child) {
        margin-left: 1rem;
      }
        }
          @include mobile {
       padding: 0;
        }
    }
  }
/deep/ { .lang-cnt {
    color: $blue;
    font-weight: bold;
    transition: all 0.3s ease;

    span {
      cursor: pointer;
      /* vertical-align: sub; */
      &:not(:last-child) {
        margin-right: 1rem;
      }
      

      &:hover {
        transition: all 0.3s ease;
        border-top: 1px solid $blue#{55};
        @include mobile {
          border-top: 2px solid white#{55} !important;
        }
      }

      &.active {
        border-top: 2px solid $blue;
      }
    }
  }
}
  @include mobile {
  /deep/ .navbar {
    //  padding: 2rem 5rem;
     padding-left: 0rem !important;
		 padding-top: .5rem;
  }
}
  .sect-height{
    @include desktop{
      min-height:150vh !important;
    }
    @include desktop-sm{
      min-height:150vh !important;
    }
    @include tablets{
      min-height:150vh !important;
    }
    @include mobile{
      min-height:160vh !important;
    }
  }
  .access-btn{
    @include media(tablets, mobile) {
    color: #3238C4 !important;
    background-color: transparent !important;    
    }
  }
  .nav-item {
    @include desktop {
      margin-right: 1rem;
    }

    @include tablets {
      padding: 2rem;
      font-size:20px;
    }

    @include mobile {
      padding: 0rem 2rem;
    }
  }
  .tick-mobile {
    @include mobile {
      margin-right:1.25rem;
    }
    @include tablets {
      margin-right:1.25rem !important;
    }
    @include desktop-sm {
      margin-right:1.25rem !important;
    }
  }
.forum {
  font-weight: bold;
  color:$blue
}
  .body{
  height: 100%;
}
  .contenedor{
  height: 49%;
  margin: 1% 1%;
}

/deep/.neu-card-general-ctn .neu-card-general {
  @include mobile {
    height: initial !important;
  }
  @include tablets {
    box-shadow: transparent !important;
  }
}

.seeker-row {
	div:not(:last-child) {
		margin-bottom: 1rem;
	}
}

/* @include desktop {
	.landing-cnt {
		box-shadow: $custom-shadow;
	}
} */

.landing-cnt h1:not(.panel), .title {
	@include desktop {
		font-size: 35px;
	}
	@include tablets {
		font-size: 35px;
	}

	@media (max-width: 1140px) { 
    font-size: 27px; /* Even smaller font size for very high zoom levels */
  }

	@include media(mobile, tablets) {
			font-size: 27px
	}
}

.text-ctn h1 {
		margin-bottom: 1rem;
	}

@include desktop {
	.menttum {
		height: 100vh;

		#menttum {
			height: 100%;
		}
	}
}



@include media(mobile, tablets) {
	.column-reverse-mobile {
		flex-direction: column-reverse;
	}
}

.menttum-container {
	@include container-padding;
	display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f4f4f4;
  border-radius: 10px;
  
	@include desktop {
		height: 100vh;
		.content {
			flex: 1;
			width: 50%;
			padding-right: 2rem;
			h2 {
				font-size: 2rem;
				margin-bottom: 1rem;
			}
		}

		.image-container {
			width: 50%;
			display: flex;
			justify-content: center;
			padding-top: 9rem;
			padding-bottom: 9rem;
			padding-left: 9rem;
			height: 100%;

			div {
				background-image: url("/static-appopensalud/img/bgs/calm-background.jpg");
				background-size: cover;
				background-position-x: center;
				background-repeat: no-repeat;
				height: 100%;
				width: 100%;
				border-radius: $border-radius;
			}
		}
	}
}

.embedded-title {
	@include desktop {
		font-size: 1.75rem !important;
	}

	@media (max-width: 1140px) {
		font-size: 1.5rem !important;
	}	

	@include media (mobile, tablets) {
		font-size: 1.5rem !important;
		margin-top: 1rem;
	}
	opacity: 0.85;
}

@include media(mobile,tablets) {
    .menttum-container {
        flex-direction: column-reverse;
				padding-bottom: 3rem;
				text-align: center;

				.image-container {
					display: flex;
					height: 30vh;
					width: 100vw;
					padding: 3rem 2rem .5rem;
					div{
						background-image: url("/static-appopensalud/img/bgs/calm-background.jpg");
						background-size: cover;
						background-position-x: center;
						background-repeat: no-repeat;
						height: 100%;
						width: 100%;
						border-radius: $border-radius;
					}

					margin-bottom: 2rem;
				}

				.first-button {
					margin-right: auto;
					margin-left: auto;
				}
    }

		.text-ctn-embedded {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
			width: 90%;
			color: white;
		}
}

@include desktop {
	.embedded-title {
		margin-bottom: 3rem !important;
	}
	.blue-block {
		margin-top: 7rem;
	}
}

/* $img-url: url("/static-appopensalud/img/bgs/opt/primavera.webp");
$heart-shape: url("/static-appopensalud/img/bgs/heart-shape.png");

.heart-image {
	@include media(desktop, landscapes) {
      width: 50vw;
			@include dvh-fallback(height, 100dvh, 100vh);
      background-size: cover;
      right: 0;
      background-position-x: right;
	}
  position: absolute;
  background-image: url("/static-appopensalud/img/bgs/opt/primavera.webp"); // your mountain image
  background-size: cover;
  background-position: center;
  border-radius: 2rem;

  mask-image: url("/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_BigHeart.png");
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;

  -webkit-mask-image: url("/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_BigHeart.png");
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
} */

</style>


// WEBPACK FOOTER //
// src/components/views/opensalud/Pacientes.vue